import { createDuck } from 'helpers/duckTools';

// export const REDUCER_KEY = 'USER';

export const userDuck = createDuck('USER', {});

export const reducer = userDuck;
